module.exports = __webpack_public_path__ + "static/img/gray_p.84423bbf.png";